import { EmployeeType, PayrollType } from "./enums.type";

export class WizardFormDto {
  information = new WizardInformationFormDto();
  scheduler: WizardSchedulerFormDto | null = null;
  hours: WizardHourFormDto[] = [];
  rates: WizardRateFormDto[] = [];
  payroll = new WizardPayrollFormDto()
}

export class WizardHourFormDto {
  day = "";
  start: string | null = null;
  end: string | null = null;
  break: string | null = null;
}

export class WizardInformationFormDto {
  practiceName = "";
  officeName = "";
  website = "";
  phone: string | null = null;
  officePhone = "";
  email = "";
  address1 = "";
  address2: string | null = null;
  city = "";
  state = "";
  zipCode = "";
}

export class WizardPayrollFormDto {
  employeeType = EmployeeType.OneZeroNineNine;
  type = PayrollType.Biweekly;
  description: string | null = null;
}

export class WizardRateFormDto {
  positionId = 0;
  position = "";
  rate = 0;
}

export class WizardSchedulerFormDto {
  firstName = "";
  lastName = "";
  email = "";
  cellPhone = "";
}